
export const ModifierKeyNames = Object.freeze({
  Control: 'Control',
  Alt: 'Alt',
  Shift: 'Shift',
  Meta: 'Meta',
})

/**
 * defines the 4 existing modifier keys
 */
export const ModifierKeys = Object.freeze({
  Control: { code: 'ControlLeft', key: 'Control', location: 1, which: 17 },
  Alt: { code: 'AltLeft', key: 'Alt', location: 1, which: 18 },
  Shift: { code: 'ShiftLeft', key: 'Shift', location: 1, which: 16 },
  Meta: { code: 'MetaLeft', key: 'Meta', location: 1, which: 91 }
})

export class ModifierFlags {
  /**
   * if a modifier is pressed on the toolbar, on first hardware key down we have to send a modifier down event first
   * true means 'Down' event was sent for that modifier
   */
  _isModifierDown = {
    Control: false,
    Alt: false,
    Shift: false,
    Meta: false
  }

  _isKeyAModifier = {
    Control: true, Alt: true, Shift: true, Meta: true
  }

  /** public */

  isDown = (modifierKey) => this._isModifierDown[modifierKey]

  setDown = (modifierKey) => {
    this._isModifierDown[modifierKey] = true
  }

  resetDown = (modifierKey) => {
    this._isModifierDown[modifierKey] = false
  }

  setDownFor = (modifierKeys) => {
    modifierKeys.forEach((k) => { this.setDown(k) })
  }

  resetDownForAll = () => {
    Object.keys(this._isModifierDown).forEach((k) => { this._isModifierDown[k] = false })
  }

  isKeyAModifier = (key) => {
    return this._isKeyAModifier[key]
  }

}

